var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[{ 'with-image': _vm.html.includes('<img'), 'deck-terms': _vm.deckTerms }, `flashcard-${_vm.type}-content`, _vm.place],domProps:{"innerHTML":_vm._s(_vm.html)}})
}
var staticRenderFns = []

export { render, staticRenderFns }